import { render } from "./ProjectSection.vue?vue&type=template&id=5015c407&scoped=true"
import script from "./ProjectSection.vue?vue&type=script&lang=js"
export * from "./ProjectSection.vue?vue&type=script&lang=js"

import "./ProjectSection.vue?vue&type=style&index=0&id=5015c407&scoped=true&lang=css"

import exportComponent from "/Users/peterdevos/Sites/sephendevos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5015c407"]])

export default __exports__